import { schema } from 'normalizr'

const prefecture = new schema.Entity('prefectures')

export default prefecture
